import { mapIE2eeMessagePayload } from 'APP/model/e2ee/e2eeModel.mapper';
import { E2eePayloadType } from 'APP/model/e2ee/e2eeModel.types';
import { WebCryptoService } from 'SERVICES/webCryptoService/WebCryptoService';

export const decodeSelfPayload = async (
  selfPayload: ArrayBuffer,
  callback: (decodedText: string) => void
): Promise<void> => {
  const decodedPayload = await WebCryptoService.parseMessage(selfPayload);

  if (!decodedPayload) {
    return;
  }
  const payload = mapIE2eeMessagePayload(decodedPayload);

  switch (payload.payloadType) {
    case E2eePayloadType.RichText: {
      callback(payload.text);
    }
  }
};
